import React from 'react';
import { CarIcon, TruckIcon, BriefcaseIcon, LaptopIcon } from 'lucide-react';
export function Services() {
  const services = [{
    title: 'Arrendamiento Puro',
    description: 'Utiliza vehículos y equipo sin necesidad de comprar.',
    benefits: ['Inversión inicial mínima.', 'Plazos de 2 a 4 años.', 'El arrendamiento puro no se considera pasivo.', 'Monto de renta es deducible de impuestos.']
  }, {
    title: 'Arrendar Transporte',
    description: 'Ofrecemos beneficios adicionales para arrendamiento de vehículos.',
    benefits: ['Precios de flotilla que trasladamos al cliente.', 'Grandes descuentos en seguros.', 'Oportunidad de regresar el auto al final del contrato y contratar uno nuevo.', 'Todos los gastos del coche son 100% deducibles (gasolina, servicios y seguro).']
  }, {
    title: 'Sale and Lease Back',
    description: 'Compramos tus activos y te los arrendamos.',
    benefits: ['Ayuda a recapitalizar tu empresa.', 'Saca los activos del balance.', 'No se registra el pasivo.', 'Solución a problemas de liquidez.', 'Se recupera una inversión importante.']
  }];
  const equipment = [{
    icon: CarIcon,
    title: 'EQUIPOS DE TRANSPORTE'
  }, {
    icon: TruckIcon,
    title: 'MAQUINARIA Y EQUIPO INDUSTRIAL'
  }, {
    icon: BriefcaseIcon,
    title: 'MOBILIARIO Y EQUIPO DE OFICINA'
  }, {
    icon: LaptopIcon,
    title: 'EQUIPO DE CÓMPUTO Y ELECTRÓNICO'
  }];
  return <section id="servicios" className="py-20 bg-[#2D2D2D]" data-id="element-219">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-220">
        <div className="mb-16" data-id="element-221">
          <h2 className="text-4xl font-light text-white mb-4" data-id="element-222">
            Nuestros Servicios
          </h2>
          <p className="text-xl text-gray-300" data-id="element-223">
            Financiamiento de Bienes de Capital
          </p>
        </div>

        {/* Service Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-224">
          {services.map((service, index) => <div key={index} className="bg-[#3D3D3D] rounded-lg p-8" data-id="element-225">
              <h3 className="text-2xl font-bold text-white mb-4" data-id="element-226">
                {service.title}
              </h3>
              <p className="text-gray-300 mb-6 italic" data-id="element-227">{service.description}</p>
              <ul className="space-y-3" data-id="element-228">
                {service.benefits.map((benefit, idx) => <li key={idx} className="text-gray-400 flex items-start" data-id="element-229">
                    <span className="text-[#2BA6DE] mr-2" data-id="element-230">•</span>
                    <span data-id="element-231">{benefit}</span>
                  </li>)}
              </ul>
            </div>)}
        </div>

        {/* Equipment Types */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-232">
          {equipment.map((item, index) => <div key={index} className="bg-[#3D3D3D] rounded-lg p-8 text-center hover:bg-[#4D4D4D] transition-colors" data-id="element-233">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#2BA6DE]/20 mb-4" data-id="element-234">
                <item.icon className="text-[#2BA6DE]" size={32} data-id="element-235" />
              </div>
              <h4 className="text-[#2BA6DE] font-bold text-sm" data-id="element-236">{item.title}</h4>
            </div>)}
        </div>
      </div>
    </section>;
}